import * as Actions from 'app/store/actions';
import _ from '@lodash';
import axios from 'axios';
import clsx from 'clsx';
import DateFnsUtils from '@date-io/date-fns';
import DefaultTab from './DefaultTab';
import DeleteIcon from '@material-ui/icons/Delete';
import Divider from '@material-ui/core/Divider';
import firebaseService from 'app/services/firebaseService';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Modernisation from './Modernisation';
import moment from 'moment';
import MuiTextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import React, {
    Component,
    useCallback,
    useEffect,
    useLayoutEffect,
    useMemo,
    useRef,
    useState
    } from 'react';
    import {FuseLoading} from '@fuse'
import ReactDOM from 'react-dom';
import ReactStars from 'react-rating-stars-component';
import SelectClients from 'app/custom/components/selects/selectClients';
import SelectContacts from 'app/custom/components/selects/selectContacts';
import SelectSites from 'app/custom/components/selects/selectSites';
import SelectVariables from 'app/custom/components/selects/selectVariable';
import TableBatiment from './tableBatiments';
import TableComponent from './tableVariables';
import AnnexesC from './components/annexeC'
import AnnexesD from './components/annexeD'
import AnnexesE from './components/annexeE'
import AnnexesF from './components/annexeF'
import {
    blue,
    green,
    grey,
    orange
    } from '@material-ui/core/colors';
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    InputLabel,
    LinearProgress,
    MenuItem,
    NativeSelect,
    Radio,
    RadioGroup,
    Select,
    TextareaAutosize,
    TextField,
    Typography
    } from '@material-ui/core';
import { config, URL_API } from 'app/services/firebaseService/firebaseServiceConfig';
import {
    createStyles,
    makeStyles,
    Theme,
    withStyles
    } from '@material-ui/core/styles';
import { deepOrange, deepPurple } from '@material-ui/core/colors';
import { FuseUtils } from '@fuse';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useDispatch, useSelector } from 'react-redux';
import { useField } from 'formik';
import { withRouter } from 'react-router';




const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);
 { /* const initialValuesForm = {
     audit:{},
    rapport: "audit",
    date: moment().format('YYYY-MM-DD'),
    date_formatted:moment().format('Do MMM YYYY'),
    site:{},
    client: {},
    gestionnaire:{},
    contact:{},
    batiments: [],
    batteries: [],
    appareils: [],
    modernisations:[], 
    elements_verifies:[],defauts:[], redacteur:{},glisse:{}, annexeC:[], annexeD:[], annexeE:[], annexeF:[]

};  */ }
 
const initialValuesForm = {"audit":{"graissage":"moyennement satisfaisant","qualite_maintenance":"insatisfaisante","nettoyage":"insatisfaisant","reglages":"satisfaisants","fiabilite_comments":"zezezeze\nzezezezz\nzezezezezezezezezez","couverture_maintenance_comments":"ezeezezeeze","fiabilite":"n'est plus assurée.","couverture_maintenance":"Les visites de maintenance sont correctement réalisées dans un intervalle de 6 semaines Maximum entre deux visites.","glisse":"moyennement satisfaisante","qualite_maintenance_comments":"sqSSQ","qualite_deplacement_comments":"","amiante":"true","conformite_ascenceur_comments":"test","decret_2008_1325":"Conforme","decret_2004_964":"Non conforme","conformite_ascenceur":"conformes","aspect_general":"moyen","amiante_comments":"TEST","carnet_entretien":"n'est pas correctement rempli","qualite_deplacement":"moyenne","developpement_durable":"false"},"rapport":"audit","date":"2020-06-13","site":{"address":"3 Place Georges Pompidou","address2":"","appareils":[{"qte":1,"type":"Escalator"},{"prix":"","qte":2,"type":"Monte-charge"}],"city":"LEVALLOIS-PERRET","client":{},"contact":{"id":"5ae6d19db4ff3643","email":"tst@email.com","name":"LAIDIE ","lastName":"Ludovic","mobile":"","phone":""},"country":"France","createdTime":"2020-05-20 11:30:56","entite":"","gestionnaire":{},"id":"3a957f98c8196167","name":"3 Place Georges Pompidou 92300 LEVALLOIS-PERRET","notes":"","type_batiment":"Immeuble ERP","zip":"92300"},"client":{"address":"64, rue Anatole France","address2":"","avatar":"assets/images/avatars/profile.jpg","city":"LEVALLOIS-PERRET","code_client":"","country":"France","createdTime":"2020-07-13 12:55:30","email":"","entite":"","fax":"","id":"9a83da2ccfe889ef","name":"TEST","notes":"","phone":"","siret":"","tva":"","updatedTime":"","zip":"92300"},"gestionnaire":{},"contact":{"access":{"abbreviation_consultant":"LLE","code_agence":"89","code_consultant":"300"},"address":"","avatar":"assets/images/avatars/profile.jpg","birthday":"","company":{"id":"9a83da2ccfe889ef","name":"TEST","entite":""},"createdTime":"2020-07-13 17:05:07","email":"llaidie@me.com","fax":"","gender":"Mr","gender_lng":"Monsieur","id":"6cec442455e32322","isUser":true,"jobTitle":"","lastName":"Ludovic","mobile":"","name":"LAIDIE","notes":"","phone":""},"batiments":[{"id":"ca367a82a8d84a3c","name":"BATIMENT 1","address":"64, Rue Anatole France"},{"id":"01ea5f518e348724","name":"BATIMENT 2","address":"64, Rue Anatole France"}],"batteries":[{"id":"ae0ddada35263c01","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true},{"id":"8803f11990438008","name":"BATTERIE 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true}],"appareils":[{"id":"e48b4c701d16656e","name":"App batterie 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz"},{"id":"972aa1ec6c5a9fd5","name":"TEST A","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz"},{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet"},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet"},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet"},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true},{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true}],"modernisations":[{"id":"e11eae84954eb760","year":"2020","description":"TEST","appareilId":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","appareil":"ae0ddada35263c01","batimentName":"BATIMENT 1","appareilName":"TEST Z"},{"id":"99d70057fb4b961f","year":"2012","description":"TEST 2","appareilId":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","appareil":"8803f11990438008","batimentName":"BATIMENT 1","appareilName":"TEST Z"},{"id":"79649f7456185212","year":"2012","description":"TEST Modernisation","appareilId":"8803f11990438008","batimentId":"01ea5f518e348724","appareil":"a641f6e9f940b5fa","batimentName":"BATIMENT 2","appareilName":"BATTERIE 2"}],"date_formatted":"13 juin 2020","elements_verifies":[{"id":"160d7995-93a6-fba5-9999-8523b6e6344a","value":"La qualité de la maintenance effectuée sur l’ascenseur "},{"id":"86d87d43-159a-c889-663e-3fca519b72e9","value":"L’état de conformité de l’ascenseur"}],"redacteur":{"access":{"abbreviation_consultant":"LLA","code_agence":"89","code_consultant":"109"},"address":"","avatar":"assets/images/avatars/profile.jpg","birthday":"","company":"9a83da2ccfe889ef","email":"ludovic@intellergy.fr","fax":"","gender":"Mr","gender_lng":"Monsieur","id":"D3TJBSHQ0FefoMowkfs6h36qWsl2","isUser":true,"jobTitle":"","lastName":"Ludovic","lastOnline":"2020-07-16T14:57:54+00:00","mobile":"","name":"LAIDIÉ ","notes":"","phone":"+33 6 98 74 62 77","updatedTime":"2020-07-13 13:44:50"},"defauts":[{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"BATTERIE 2","batterieId":"8803f11990438008","value":"TEST 1","id":"b65420a336632f41","check":true,"localisation":"Toit de cabine","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"BATTERIE 2","batterieId":"8803f11990438008","value":"TEST","id":"37152df1f28b1686","check":true,"localisation":"Machinerie/Hydraylique","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"BATTERIE 2","batterieId":"8803f11990438008","value":"Remplacer la boite Pompiers ","id":"b5f87c3b90efd065","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"BATTERIE 2","batterieId":"8803f11990438008","value":"Refixer le dispositif de maintien de trappe ouverte","id":"34d3780ab98d10be","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"BATTERIE 2","batterieId":"8803f11990438008","value":"Remplacer ou réparer la serrure de la porte de machinerie","id":"907647c478aef7da","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"TEST","batterieId":"ae0ddada35263c01","value":"Mettre à jour l’étude de sécurité","id":"ab27497613ae48d2","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"TEST","batterieId":"ae0ddada35263c01","value":"Refixer le dispositif de maintien de trappe ouverte","id":"bdb1b5250f3bce97","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","batterieName":"TEST","batterieId":"ae0ddada35263c01","value":"Revoir le dispositif de contrebalancement de la trappe, ce dernier est inefficace","id":"fadca3fcbc8be6a3","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","appareilName":"TEST S","appareilId":"d494642cce6d2e80","value":"Remplacer ou réparer la serrure de la porte de machinerie","id":"269ae20a3d1f4633","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","appareilName":"TEST Z","appareilId":"0a784685ac9258fe","value":"TEST 1","id":"6560eccc78884074","check":true,"localisation":"Toit de cabine","etages":"1,2"},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","appareilName":"TEST Z","appareilId":"0a784685ac9258fe","value":"Mettre à jour l’étude de sécurité","id":"de008cec8273b3b6","check":true,"localisation":"Machinerie","etages":"1,2,3"},{"batimentName":"BATIMENT 1","batimentId":"ca367a82a8d84a3c","appareilName":"TEST Z","appareilId":"0a784685ac9258fe","value":"Remplacer ou réparer la serrure de la porte de machinerie","id":"4c93ae957c7024f7","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 1","appareilId":"a516d7d03252be65","value":"TEST 1","id":"17bc946c65e73886","check":true,"localisation":"Toit de cabine","etages":""},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 1","appareilId":"a516d7d03252be65","value":"TEST","id":"7d8b4f4b3e9a6c95","check":true,"localisation":"Machinerie/Hydraylique","etages":""},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 1","appareilId":"a516d7d03252be65","value":"Remplacer la boite Pompiers ","id":"0fb5f7ff147d0189","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 1","appareilId":"a516d7d03252be65","value":"Revoir le dispositif de contrebalancement de la trappe, ce dernier est inefficace","id":"76cac6d6079b1dce","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 3","appareilId":"a641f6e9f940b5fa","value":"TEST 1","id":"61314ac374461d64","check":true,"localisation":"Toit de cabine","etages":"1,2,3"},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 3","appareilId":"a641f6e9f940b5fa","value":"Mettre à jour l’étude de sécurité","id":"2c8efbbfd41a2eed","check":true,"localisation":"Machinerie","etages":""},{"batimentName":"BATIMENT 2","batimentId":"01ea5f518e348724","appareilName":"TEST 3","appareilId":"a641f6e9f940b5fa","value":"Revoir le dispositif de contrebalancement de la trappe, ce dernier est inefficace","id":"ef33010efd94c863","check":true,"localisation":"Machinerie","etages":""}],"glisse":{"graissage":"moyennement satisfaisant","qualite_maintenance":"insatisfaisante","nettoyage":"insatisfaisant","reglages":"satisfaisants","fiabilite":"n'est plus assurée."},"entreprise_maintenance":"FAIN","annee_construction":"1980","marque_appareil":"SCHINDLER","annexeC":[{"id":"d529df3cea632ade","pu":"300","description":"Sds","batiment":"","appareil":"","appareils":[{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"e48b4c701d16656e","name":"App batterie 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"972aa1ec6c5a9fd5","name":"TEST A","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"batimentId":"ca367a82a8d84a3c","localisation":"Hatem","pt":3300},{"id":"bfbe000d7a5a1b66","pu":"300","description":"Sdswds","batiment":"","appareil":"","appareils":[{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"batimentId":"ca367a82a8d84a3c","localisation":"Hatem","pt":600},{"id":"b20ad5f41ebc89c1","pu":"200","description":"Sdswdssds","batiment":"","appareil":"","appareils":[{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"batimentId":"ca367a82a8d84a3c","localisation":"Machinerie","pt":1200}],"annexeD":[{"article":"Article GH 31 § 2 ","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p>Si la protection est r&eacute;alis&eacute;e &agrave; l'aide de portes pali&egrave;res coupe-feu par elles-m&ecirc;mes, les prescriptions suivantes doivent &ecirc;tre respect&eacute;es :</p>\n<ol style=\"list-style-type: lower-alpha;\">\n<li>Forcer la fermeture des portes pali&egrave;res d'ascenseur ou de monte-charges au bout de trente secondes maximum ;</li>\n<li>Indiquer au poste central de s&eacute;curit&eacute; incendie de la non-fermeture des portes lorsqu'elle se prolonge au-del&agrave; de 60 secondes conform&eacute;ment &agrave; l'article GH 26 ;</li>\n<li>Signaler la position des cabines au poste central de s&eacute;curit&eacute; incendie ;</li>\n<li>Interdire le maintien en position ouverte des portes pali&egrave;res lors des op&eacute;rations de d&eacute;pannage ou d'entretien ;</li>\n<li>Annuler la man&oelig;uvre &agrave; commande accompagn&eacute;e en cas de d&eacute;tection incendie ou d'appel prioritaire.</li>\n</ol>","id":"27b76a479d8d1d43","reglementation":"IGH","value":""},{"article":"Article GH 30 § 7 ","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p>Installer des parois supports en cabine, avec des mat&eacute;riaux de cat&eacute;gorie M0 ou A1.</p>\n<p>Les rev&ecirc;tements de la cabine sont en mat&eacute;riaux de cat&eacute;gories :</p>\n<ul>\n<li>M3 ou Cfl-s1 au sol ;</li>\n<li>M1 ou C-s2, d0 pour les parois verticales, le plafond et les luminaires.</li>\n</ul>","id":"2bd0be6a4759ba53","reglementation":"IGH","value":""},{"article":"Article GH 32 § 1 ","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p>Installer une plaque signal&eacute;tique bien visible, qui rappelle la n&eacute;cessit&eacute; de laisser libre de tout obstacle, le d&eacute;gagement n&eacute;cessaire au fonctionnement des portes coupe-feu &agrave; fermeture automatique.</p>\n<p>Indiquer l'inscription de cette plaque en lettres blanches sur fond rouge.</p>","id":"dc5f08d1f4d23ef7","reglementation":"IGH","value":""},{"article":"Article GH 32 § 2 ","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p>Faire en sorte que les dispositifs de fermeture des paliers de desserte, quand ils existent, et les portes d'ascenseurs et monte-charge, ne doivent ni recouper, ni r&eacute;tr&eacute;cir les circulations horizontales communes du compartiment.</p>","id":"ef96689109d56c2f","reglementation":"IGH","value":""},{"article":"Article GH 33 § 5 ","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p>Prendre toutes les dispositions utiles, lors de l'entretien d'une cabine, afin de maintenir en fonctionnement les autres cabines situ&eacute;es dans la m&ecirc;me cage.</p>","id":"11def7d2d053865d","reglementation":"IGH","value":"","appareils":[{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}]},{"article":"Article GH 30 § 3 ","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p>Equiper les cabines d&rsquo;ascenseurs d'un dispositif de commande accompagn&eacute;e, destin&eacute;, une fois actionn&eacute;, &agrave;&nbsp;:</p>\n<p>Inhiber le fonctionnement de l'ascenseur vis-&agrave;-vis des appels paliers et cabine d&eacute;j&agrave; enregistr&eacute;s et &agrave; permettre une utilisation uniquement &agrave; partir du panneau de commande en cabine.</p>\n<p>(L'utilisation de cette commande, d'un mod&egrave;le unique, est r&eacute;serv&eacute;e aux personnes autoris&eacute;es et averties.</p>\n<p>Quatre exemplaires de ce dispositif de commande sont tenus, au poste central de s&eacute;curit&eacute; incendie, &agrave; la disposition du commandant des op&eacute;rations de secours.)</p>","id":"15f86d5154ed1400","reglementation":"IGH","value":"","appareils":[{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}]}],"annexeE":[{"article":"II.6","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif de protection du personnel d’intervention contre le risque de happement par les organes mobiles de transmission, notamment les poulies ou courroies.</strong></p>\n<p>Mise en place de protection des points rentrants adaptables à tout type d’installation.</p>","id":"1ca86ba7cbfe7285","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":""},{"article":"III.2","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif de protection contre la vitesse excessive de la cabine en montée pour un ascenseur électrique à adhérence avec charge supérieure à 320Kg.</strong></p>\n<p>Mise en place d’un limiteur de vitesse par prise à double sens. Remplacement des blocs parachute par des blocs à prise montée descente, tendeur limiteur adapté, parachute contre poids si nécessaire, frein de poulie ou de câbles ou de guides.</p>","id":"1e5dfa6c5fe38dca","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2018","value":""},{"article":"I.7","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Protection des intervenants en gaine et sur toit de cabine.</strong></p>\n<p>Remplacement ou mise en place d’un boîtier d’inspection sur le toit de cabine avec dispositif d’arrêt fin de course en gaine. Installation d’un éclairage complet en gaine. Garde corps sur toit. Echelons en cuvette avec crosse de rétablissement.</p>","id":"270692f50fc9f824","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"II.5","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Système de protection avec marquage ou signalisation éliminant le risque de contact direct du personnel d’intervention avec des composants ou conducteurs nus sous tension, dans les armoires de commande, les armoires électriques et les tableaux d’arrivées de courant.</strong></p>\n<p>Mise en place d’un tableau électrique d’arrivée force type DTU, de coffrets de protection de l’armoire de manœuvre ou remplacement par une armoire conforme.</p>","id":"2a5d54fc2be76468","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":""},{"article":"I.1","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Serrures munies de dispositifs de contrôle de la fermeture et du verrouillage des portes palières.</strong></p>\n<p>Mise en place de serrures conformes (pêne, gâche et contact) ayant fait l’objet d’un essai de type et équipées d’un contrôle électrique de la fermeture de porte et d’un triangle de déverrouillage<em>.</em></p>","id":"39847193fa60a59c","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":"","pu":"1300","appareils":[{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}]},{"article":"II.1","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Système de contrôle de l’arrêt et du maintien à niveau de la cabine d’ascenseur, de nature à assurer, à tous les niveaux desservis, un accès sans danger ainsi que l’accessibilité des personnes handicapées ou à mobilité réduite dans les ascenseurs installés antérieurement au 1<sup>er</sup> janvier 1983.</strong></p>\n<p>Mise en place d’une armoire à variation de fréquence garantissant la précision de l’arrêt et dispositif de blocage de la cabine en cas de déplacement incontrôlé. Remplacement de la machine, des canalisations électriques, boites à boutons et signalisations ou coffret additif pour variation de fréquence.</p>","id":"4eda9d2b04f5f42f","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":""},{"article":"I.2","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif empêchant ou limitant les actes susceptibles de porter atteinte au verrouillage de la porte palière, lorsque cela est nécessaire.</strong></p>\n<p>Mise en place d’un avertisseur sonore et lumineux déclenché lors de l’ouverture de la porte palière en l’absence de la cabine à l’étage. Dispositif sécurisé interdisant l’ouverture manuelle de la porte palière.</p>","id":"61df6906feb6732f","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":"","pu":"1400","appareils":[{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"e48b4c701d16656e","name":"App batterie 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"972aa1ec6c5a9fd5","name":"TEST A","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}]},{"article":"II.4","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif de protection contre la chute libre, la dérive et la survitesse de la cabine pour un ascenseur hydraulique.</strong></p>\n<p>Mise en place d’une vanne parachute pour les ascenseurs à vérin direct. Adjonction d’un parachute ou équivalent, sur la cabine pour les ascenseurs avec vérin mouflé, ce dispositif sera couplé à un système de contrôle mou de câble ou un limiteur de vitesse. Maintien de la cabine dans sa zone de déverrouillage par un système d’isonivelage et retour automatique. Contrôle permanent de la position de la cabine.</p>","id":"701078cf201f03b5","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":""},{"article":"I.5","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Parachute de cabine et limiteur de vitesse en descente dans un ascenseur électrique.</strong></p>\n<p>Mise en place d’un limiteur de vitesse couplé à un parachute approprié. (Limiteur, parachute aléatoire)            </p>","id":"725f68405cacac66","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"I.8","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif permettant au personnel d’intervention d’accéder sans danger aux locaux de machines ou de poulies.</strong></p>\n<p>Mise en conformité des accès. Marchepied machinerie, barre de préhension.                                                                      </p>","id":"7735dd63bf840b81","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"I.9","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif de verrouillage inexistant ou inadéquat sur les portes</strong></p>\n<p><strong>De visite en gaine, de secours en gaine et accès à la cuvette</strong></p>","id":"7c0338ade94db6db","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"I.6","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif destiné à éviter toute chute en gaine lorsque la cabine est immobilisée en dehors de la zone de déverrouillage.</strong></p>\n<p>Mise en place d’une tôle garde pied cabine fixe ou rétractable.</p>","id":"7da6b4e3c177255a","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"II.3","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Porte palière présentant une résistance mécanique suffisante lorsqu’elles comportent un vitrage.</strong></p>\n<p>Remplacement du verre ne présentant pas une résistance mécanique suffisante par un verre armé ou feuilleté, selon les dimensions, ou obturation du regard vitré et adjonction d’un voyant lumineux indiquant la présence de la cabine.</p>","id":"7dddc8f280098f5e","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":""},{"article":"I.3","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Système de détection de présence des personnes destiné à les protéger contre le choc des portes coulissantes lors de leur fermeture.</strong></p>\n<p>Mise en place d’une barrière de cellules qui détecte la présence d’une personne sans contact physique<em>.</em></p>","id":"ab475405525001f4","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"I.4","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif de clôture des gaines empêchant l’accès à ces gaines et aux éléments de déverrouillage des serrures des portes palières.</strong></p>\n<p>Protection complète de la gaine grillagée avec taille de maille conforme au texte réglementaire en vigueur.</p>","id":"c996591b87f4e555","reglementation":"Travaux et dispositifs à mettre en place avant le 31 décembre 2010","value":""},{"article":"II.2","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif de téléalarme entre la cabine et un service d’intervention, doublé d’un éclairage de secours en cabine.</strong></p>\n<p>Mise en place d’un système de communication bidirectionnel tri phonique ou rendre l’existant conforme avec éclairage de secours autonome en cabine.</p>","id":"cab6d95407eb2809","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":""},{"article":"III.1","check":false,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Système de contrôle de l’arrêt et du maintien à niveau de la cabine d’ascenseur, de nature à assurer, à tous les niveaux desservis, un accès sans danger ainsi que l’accessibilité des personnes handicapées ou à mobilité réduite dans les ascenseurs installés postérieure au 31 décembre 1982.</strong></p>\n<p>Mise en place d’une armoire à variation de fréquence garantissant la précision de l’arrêt et dispositif de blocage de la cabine en cas de déplacement incontrôlé. Remplacement de la machine, des canalisations électriques, boites à boutons et signalisations ou coffret additif pour variation de fréquence.</p>","id":"d07a0875fb2a66ab","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2018","value":""},{"article":"II.7","check":true,"createdBy":"D3TJBSHQ0FefoMowkfs6h36qWsl2","description":"<p><strong>Dispositif d’éclairage fixe du local de machines ou de poulies assurant un éclairement suffisant des zones de travail et de circulation.</strong></p>\n<p>Mise en place d’un ensemble d’éclairage avec dispositif de commande et éclairage de secours ou mise en conformité de l’existant.</p>","id":"d90aa3e0f16a9b38","reglementation":"Travaux et dispositifs à mettre en place avant le 3 juillet 2014","value":"","pu":"1200"}],"annexeF":[{"id":"9c70bdf1f39ef503","pu":345,"description":"Remplacement du contrôleur de manœuvre par un modèle à variation de fréquence. ","appareils":[{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"e48b4c701d16656e","name":"App batterie 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"972aa1ec6c5a9fd5","name":"TEST A","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"localisation":"Machinerie","pt":3795},{"id":"c4db07eb856eaafc","pu":345,"description":"Test","appareils":[{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"localisation":"Machinerie/Hydraylique","pt":690},{"id":"a4d82c4d68248657","pu":3452,"description":"Test","appareils":[{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"e48b4c701d16656e","name":"App batterie 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"972aa1ec6c5a9fd5","name":"TEST A","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"localisation":"Machinerie/Hydraylique","pt":37972},{"id":"87c4b57ae5f2f954","pu":3452,"description":"Remplacement du contrôleur de manœuvre par un modèle à variation de fréquence. ","appareils":[{"id":"a6bf5ad2d9e1bd6b","name":"TEST","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"126e860bdd24d049","name":"TEST 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"d494642cce6d2e80","batimentId":"ca367a82a8d84a3c","name":"TEST S","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"da8f702a76fe0c81","name":"TEST 3","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"0a784685ac9258fe","batimentId":"ca367a82a8d84a3c","name":"TEST Z","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"e48b4c701d16656e","name":"App batterie 2","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"b6bb765672ab6908","batimentId":"ca367a82a8d84a3c","name":"TEST G","marque_appareil":"MITSUBISHI","situation_machinerie":"Basse déportée","controleur":"LL","charge":900,"entrainement":"Adhérence","vitesse":900,"porte_cabine_type":"Manuelles","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":920,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_IGH":false,"reglementation_ERP":true,"parentId":"ca367a82a8d84a3c","selected":true,"isAppareil":true,"isGroup":false},{"id":"dcc2d28f0e49606a","name":"TEST 4","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":false,"machinerie_commune":true,"batterieId":"ae0ddada35263c01","situation_machinerie":"Haute","controleur":"k","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":900,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/2","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"ae0ddada35263c01","selected":true,"isAppareil":true,"isGroup":false},{"id":"972aa1ec6c5a9fd5","name":"TEST A","batimentId":"ca367a82a8d84a3c","marque_appareil":"KONE","reglementation_IGH":true,"machinerie_commune":true,"batterieId":"8803f11990438008","situation_machinerie":"Basse déportée","controleur":"Z","entrainement":"Adhérence","charge":900,"vitesse":2,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Centrale","porte_cabine_passage_libre":800,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":4,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Triplex","manoeuvre_destination":"Collective montée/descente","suspension":"2/1","local_poulies":"Sans objet","local_poulies_commentaires":"zzz","parentId":"8803f11990438008","selected":true,"isAppareil":true,"isGroup":false},{"id":"a516d7d03252be65","batimentId":"01ea5f518e348724","name":"TEST 1","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false},{"id":"a641f6e9f940b5fa","batimentId":"01ea5f518e348724","name":"TEST 3","marque_appareil":"THEVENON-SCHINDLER ","situation_machinerie":"Basse déportée","controleur":"S","entrainement":"Tambour","charge":800,"vitesse":2.8,"porte_cabine_type":"Automatiques","porte_cabine_nombre_vantaux":3,"porte_cabine_ouverture":"Latérale","porte_cabine_passage_libre":700,"porte_paliere_type":"Battantes pleines","porte_paliere_nombre_vantaux":3,"porte_paliere_ouverture":"Latérale","manoeuvre_type":"Duplex","manoeuvre_destination":"Collective descente","suspension":"2/1","local_poulies":"Sans objet","reglementation_habitation":true,"parentId":"01ea5f518e348724","selected":true,"isAppareil":true,"isGroup":false}],"localisation":"Machinerie","pt":37972,"option":true,"variante":true}],"terme_modernisation":"à moyen terme (2 à 3 ans)"}
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    root: {
        display: 'flex',
        '& > *': { 
            margin: theme.spacing(1),
        },
    },
    batteries: {
        //color: theme.palette.getContrastText(deepOrange[500]),
        //backgroundColor: deepOrange[500],
        // opacity: .7,
        // zIndex: 10
    },
    appareils: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],

    },
}));
const colorArray = ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
    '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
    '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
    '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
    '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
    '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
    '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
    '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
    '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
    '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']

const Rating = props => {

}

const CheckBox = (props) => {


    const initialForm = useSelector(({ custom }) => custom.rapports.form);
    const [state, setState] = useState({})
    useEffect(() => {
        if (!_.isEqual(state[props.currentTarget.name], initialForm)) {

            setState({ ...state, [props.currentTarget.name]: initialForm })
        }
    }, [initialForm])

    return (
        <Checkbox checked={initialForm.data[props.currentTarget.name]} />
    );
}
{/* const TextField = (props) => {


        const initialForm = useSelector(({ custom }) => custom.rapports.form);
    const [state, setState] = useState({})
    useEffect(() => {
        if (!_.isEqual(state[props.currentTarget.name], props.currentTarget.value)) {

            setState({ ...state, [props.currentTarget.name]: props.currentTarget.value })
        }
    }, [props.currentTarget.name, props.currentTarget.value])

    return <TextField {...props} />

} */}

const Table = (props) => {

    const initialForm = useSelector(({ custom }) => custom.rapports.form);
    const [state, setState] = useState({})
    useEffect(() => {
        if (!_.isEqual(state[props.name], props.value)) {
            ////////console.log(props, field)
            setState({ ...state, [props.name]: props.value })
        }
    }, [props.name, props.value])

    return <TableComponent {...props} />

}

const TableBat = (props) => {
////////console.log(props)
    const initialForm = useSelector(({ custom }) => custom.rapports.form);
    const [state, setState] = useState({})

    useEffect(() => {
        if (!_.isEqual(state[props.name], props.value)) {
            ////////console.log(props, field)
            setState({ ...state, [props.name]: props.value })
        }
    }, [props.name, props.value])

    return <TableBatiment {...props} />

}
function createTableAnnexesA(batiment, values) {
    //////////console.log(batiment, values)
    var batteries = {}
    var appareils = []
    var length = 0
    values.appareils = _.sortBy(_.sortBy(values.appareils,'batimentId'), 'batterieId')
    _.map(values.appareils, b => {
//////console.log(b.name, b.batterieId)
        if (b.batimentId === batiment.id) {
            //////////console.log(b.batterieId, _.find(values.batteries, { id: b.batterieId, batimentId: b.batimentId }))
            if (b.batterieId) {
                if (!batteries[b.batterieId])
                    batteries[b.batterieId] = { ..._.find(values.batteries, { id: b.batterieId, batimentId: b.batimentId }), appareils: [b] }
                else batteries[b.batterieId] = { ..._.find(values.batteries, { id: b.batterieId, batimentId: b.batimentId }), appareils: _.concat(batteries[b.batterieId].appareils, b) }
                length++
            } else if (!b.batterieId) {
               
                if (!batteries['-'])
                    batteries['-'] = { id: '-', name: '', appareils: [{ ...b }] }
                else batteries['-'] = { id: '-', name: '', appareils: _.concat(batteries['-'], {...b}) }
                length++
            }
            appareils = _.concat(appareils, b)
        }
    })
    batteries = _.sortBy(_.values(batteries), 'id')

    var data = {}
    _.map(['marque_appareil','type_appareil','situation_machinerie','controleur','machine','charge','nombre_niveaux','niveaux_desservis','vitesse','porte_cabine_type','porte_paliere_type','porte_paliere_type','manoeuvre_type','local_poulies','suspension','entrainement'], (i) => {

        if (!_.includes(['annee_construction','batimentId', 'id', 'annee_construction','batterieId', 'porte_cabine_nombre_vantaux', 'porte_cabine_ouverture', 'porte_cabine_passage_libre', 'manoeuvre_destination', 'porte_paliere_nombre_vantaux',
            'porte_paliere_ouverture', 'local_poulies_commentaires', 'reglementation_IGH', 'reglementation_ERP', 'reglementation_habitation', 'machinerie_commune'], i)) {
            var name = i
            switch (i) {

                case 'marque_appareil':
                    name = "Marque";
                    break;
                case 'type_appareil':
                    name = "Type d'appareil";
                    break;
                case 'situation_machinerie':
                    name = "Situation machinerie";
                    break;
                case 'controleur':
                    name = "Contrôleur / Fabricant";
                    break;
                case 'machine':
                    name = "Machine / Fabricant";
                    break;
                case 'charge':
                    name = 'Charge';
                    break;
                case 'nombre_niveaux':
                    name = 'Nombre de niveaux';
                    break;
                case 'niveaux_desservis':
                    name = 'Niveaux desservis';
                    break;
                case 'vitesse':
                    name = 'Vitesse';
                    break;
                case 'porte_cabine_type':
                    name = 'Porte cabine';
                    break;
                case 'porte_paliere_type':
                    name = 'Porte palière';
                    break;
                case 'manoeuvre_type':
                    name = 'Type manoeuvre';
                    break;
                case 'local_poulies':
                    name = 'Local poulies';
                    break;
                case 'suspension':
                    name = 'Suspension';
                    break;
                case 'entrainement':
                    name = 'Entraînement';
                    break;
                case 'reglementation':
                    name = 'Règlementation';
                    break;
                default:
                    name = i;
                    break;
            }
            data[i] = { name: name }
        }
    })
    data.reglementation= { name: 'Règlementation' }
    _.map(_.orderBy(appareils, ['batimentId', 'batterieId']), (c) => {


        var batt = {}
        var nbre = ''
        if (c.batterieId ) {
            batt = _.find(batteries, { 'id': c.batterieId })
    
        }
  
        _.map(c, (val, j) => {
          
            if (!data[j])
             data[j]={}
            if (!_.includes(['annee_construction','batimentId', 'id', 'batterieId', 'name', 'porte_cabine_nombre_vantaux', 'porte_cabine_ouverture', 'porte_cabine_passage_libre', 'manoeuvre_destination', 'porte_paliere_nombre_vantaux',
                'porte_paliere_ouverture', 'local_poulies_commentaires',  'reglementation_IGH', 'reglementation_ERP', 'reglementation_habitation','machinerie_commune'], j)) {
            
                val = val
                switch (j) {
                    case 'charge':
                       val = val+ ' kg';
                        break;
                    case 'vitesse':
                        val= val +' m/s';
                        break;
                    case 'situation_machinerie':
                        val = `${val} ${batt && batt.machinerie_commune ? 'commune aux ' + batt.appareils.length + ' appareils' : ''}`
                        break;
                    case 'porte_cabine_type':
                        val = `${val} | ${c.porte_cabine_nombre_vantaux} vantaux | Ouverture: ${c.porte_cabine_ouverture} | Passage libre: ${c.porte_cabine_passage_libre} mm`
                        break;
                    case 'porte_paliere_type':
                        val = `${val} | ${c.porte_paliere_nombre_vantaux} vantaux | Ouverture: ${c.porte_paliere_ouverture} `
                        break;
                    case 'manoeuvre_type':
                       val  = `${c.manoeuvre_type} ${c.manoeuvre_destination}`;
                        break;
                    case 'local_poulies':
                        val = `${val} ${c.local_poulies_commentaires ? c.local_poulies_commentaires:''}`
                        break;
                    default:
                    val = val
                        break;
                }
                
                if (!val)
                    data[j][c.name] = ''
               else data[j][c.name] = val
                data.reglementation[c.name] = `${c.reglementation_IGH ? 'IGH' : ''} ${c.reglementation_ERP ? 'ERP' : ''} ${c.reglementation_habitation ? 'Habitation' : ''}`

            }
        })


    })
   //////console.log(data)
    return (
        <table style={{ width: "100%", borderCollapse: 'collapse', border: '1px solid black', font: 'Arial', fontSize: '10px', whiteSpace: 'pre-line', wordWrap: 'break-word' }}>
            <thead>
                <tr>

                    <th colSpan={1} style={{ border: '1px solid black', textAlign: 'center', backgroundColor: '#c5d1d0', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}><font face="Arial" size="10px">{'Bâtiment'}</font></th>
                    <th colSpan={length} style={{ border: '1px solid black', textAlign: 'center', backgroundColor: '#c5d1d0', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}><font face="Arial" size="10px">{batiment.name}</font></th>


                </tr>
                {batteries.length > 0  && <tr>
                    <th style={{ border: '1px solid black', textAlign: 'center', width: '150px', backgroundColor: '#c5d1d0', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}>  <font face="Arial" size="10px">{'Batterie'}</font></th>
                    {
                        _.map(batteries, (rowData, i) => {

//console.log(rowData)

                            return (<th key={i} colSpan={rowData.appareils.length} style={{ backgroundColor: rowData.id !== '-'?colorArray[i]:'#FFFFFF', opacity: 0.7, border: '1px solid black', textAlign: 'center', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}>  <font face="Arial" size="10px">{rowData.name}</font></th>);


                        })
                    }
                </tr>}
                <tr>
                    <th style={{ border: '1px solid black', textAlign: 'center', width: '150px', backgroundColor: '#c5d1d0', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}>  <font face="Arial" size="10px">{'Réf. Appareil'}</font></th>
                    {
                        _.map(_.sortBy(appareils, 'batterieId'), (rowData, i) => {



                            return (<th key={i} style={{ border: '1px solid black', textAlign: 'center', backgroundColor: '#c5d1d0', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}>  <font face="Arial" size="10px">{rowData.name}</font></th>);


                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                    _.map(_.values(data), (rowData, i) => {


                        return (<tr key={i}>
                            {

                                _.map(_.values(rowData), (cellData, j) => {
                                    //////////console.log(cellData, j)
                                    var d = 1;

                                    for (var l = j + 1; l < _.values(rowData).length; l++) {

                                        if (cellData == _.values(rowData)[l]) {
                                            d++
                                        } else break;
                                    }
                                    if (cellData !== 'name') {
                                        if (j > 0 && _.values(rowData)[j - 1] !== cellData)
                                            return (<td key={j} colSpan={d} style={{ border: '1px solid black', textAlign: 'center', font: 'Arial', fontSize: '10px', whiteSpace: 'pre-line', wordWrap: 'break-word' }}><font face="Arial" size="10px">{_.isArray(cellData) ? cellData.join(' ') : cellData}</font></td>);
                                        else if (j == 0)
                                            return (<td key={j} style={{ border: '1px solid black', textAlign: 'left', width: '100px', whiteSpace: 'pre-line', wordWrap: 'break-word' }}><font face="Arial" size="10px"> {cellData}</font></td>);
                                        /* else 
                                            return (<td key={j} colSpan={d}  style={{ border: '1px solid black', textAlign: 'center', font: 'Arial', fontSize: '10px', whiteSpace: 'pre-line', wordWrap: 'break-word' }}><font face="Arial" size="10px">{_.isArray(cellData) ? cellData.join(' ') : cellData}</font></td>);
                               */     }
                                })
                            }
                        </tr>);
                    })
                }
            </tbody>
        </table>
    )
}

function createTableAnnexesB(b, values) {
    // values = _.orderBy(values, ['batimentName', 'batterieName', 'appareilName','localisation'])
    //////console.log(values);
    var Results = {};
    _.map(values, c => {
        if (!Results[c.batimentName]) Results[c.batimentName] = {};

        //batterie & appareils
        if (c.batterieId && c.batimentId) {
            if (!Results[c.batimentName][c.batterieName])
                Results[c.batimentName][c.batterieName] = {};
            if (!Results[c.batimentName][c.batterieName][c.localisation])
                Results[c.batimentName][c.batterieName][c.localisation] = _.filter(
                    values,
                    e => {
                        return (
                            e.batimentId === c.batimentId &&
                            e.batterieId === c.batterieId &&
                            e.localisation === c.localisation
                        );
                    }
                );
        } else {
            if (!Results[c.batimentName][c.appareilName])
                Results[c.batimentName][c.appareilName] = {};
            if (!Results[c.batimentName][c.appareilName][c.localisation])
                Results[c.batimentName][c.appareilName][c.localisation] = _.filter(
                    values,
                    e => {
                        return (
                            e.batimentId === c.batimentId &&
                            e.batterieId === c.batterieId &&
                            e.localisation === c.localisation
                        );
                    }
                );
        }

        return c;
    });

    //////console.log(Results);

    ////////console.log(result);

    return _.map(Results, (c, batiment) => {
        return (
            <table
                key={batiment}
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word"
                }}
            >
                <thead>
                    <tr>
                        <th
                            colSpan={1}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word"
                            }}
                        >
                            <font face="Arial" size="10px">
                                {""}
                            </font>
                        </th>
                        <th
                           
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word"
                            }}
                        >
                            <font face="Arial" size="10px">
                                {batiment}
                            </font>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {_.map(c, (d, batterie) => {
                        var length = 1;
                        return (
                            <tr key={batterie}>
                                <td
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        verticalAlign: "top",
                                        width: 150
                                    }}
                                 
                                >
                                    <h4    style={{ textAlign: "left", marginLeft: 10 }}>{batterie}</h4>
                                </td>
                                <td
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        overflowWrap: 'break-word'
                                    }}
                                >
                                    {_.map(d, (e, localisation) => {
                                        return (
                                            <div
                                                key={localisation}
                                                style={{ textAlign: "left", marginLeft: 10 }}
                                            >
                                                
                                                    <b><u>{localisation}</u></b>
                                             
                                              
                                                    {_.map(e, m => {
                                                        if(m.lever)
                                                        return (
                                                            <div key={m.id}>
                                                                <font face="Arial" size="10px">
                                                                   <strike> {length++} - {m.value} {m.etages?m.etages:''}</strike>
                                                                </font>
                                                            </div>
                                                        );
                                                         return (
                                                            <div key={m.id}>
                                                                <font face="Arial" size="10px">
                                                                   {length++} - {m.value} {m.etages?m.etages:''}
                                                                </font>
                                                            </div>
                                                        );
                                                    })}
                                               
                                                <br/>
                                            </div>
                                        );
                                    })}
                                </td>
                            </tr>
                        );
                    })}{" "}
                </tbody>
            </table>
        );
    });
}
function createTableAnnexesC(b, values) {
    // values = _.orderBy(values, ['batimentName', 'batterieName', 'appareilName','localisation'])
    //////console.log(values);
    var Results = {};
    _.map(values, c => {
        if (!Results[c.localisation])
            Results[c.localisation]={}

   
          
            if (!Results[c.localisation][c.description])
                Results[c.localisation][c.description] = _.filter( 
                    values,
                    e => {
                        return (
                        e.description == c.description &&
                            e.localisation === c.localisation
                        );
                    }
                )
           
        

        return c;
    });

    //////console.log(Results);

console.log(Results);

   
        return (
             
            <table
              
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
               
                }}
            >
              <thead>
                    <tr>
                        <th
                            colSpan={1}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word"
                            }}
                        >
                            <font face="Arial" size="10px"> Localisation</font>
                          
                        </th>
                        <th
                
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word"
                            }}
                        >
                          
                                {""}
                        
                        </th>
                    </tr>
                </thead> 
                <tbody>
                    {_.map(Results, (c, localisation) => {
                        var length = 1;
                      var i=1
                       var total=0
                        return (
                            <tr key={localisation}>
                                <td
                                   /*  rowSpan={_.filter(values,f=>{
                                        return f.localisation == localisation
                                    }).length-1} */
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        verticalAlign: "top",
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {localisation}</b></font>
                                </td>
                                <td
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                         wordWrap: "break-word",
                                         overflowWrap: 'break-word'
                                    }}
                                >
                                
                                 
                                        {_.map(c, (d, description) => {
                                          
                                     
                                            return (
                                                <div key={description} style={{marginLeft:10}}>
                                                    <font face="Arial" size="10px"> 
                                                {i++} - {description}
                                                
                                          
                                                    {_.map(d, (m, t) => {
       total = total +m.pt
                                                        return (
                                                            <div key={t}>  

                                                               <div style={{ textAlign: 'right', justifyContent: 'end' }}>   Prix par appareil: <b>{m.pu} € HT </b>  -   Prix Total: <b>{m.pt} € HT</b></div>

                                                        <br/>
                                                                <u>Appareils concernés:</u>
                                                          
                                                                {_.map(m.appareils, (l, j) => {
return l.name
                                                                }).join(', ')
                                                                }
                                                     
                                                            {  /*   <ul>
                                                                    {_.map(m.appareils, (l, j) => {
                                                                        return <li key={j}> <font face="Arial" size="10px"> <em>{l.name}</em>  </font></li>
                                                                    })}
                                                                </ul> */}
                                                            </div>


                                                        );
                                                    })}
                                               
                                              </font>
                                                    <br/></div>

                                            )
                                        })}
                                          <div style={{ textAlign: 'right', justifyContent: 'end' }}><font face="Arial" size="10px">   <u>Sous-total {localisation}</u>: <b>{total} € HT</b></font></div>    
                                              
                                
                                </td>
                            </tr>
                        )
                    })}
                    <tr>
                    <td></td>
                              <td style={{textAlign:'right', justifyContent:'end'}}>  <font face="Arial" size="12px">     <b>Montant Total des Améliorations : {_.sum(_.map(values,c=>c.pt))} € HT </b></font></td>
                    </tr>
                  </tbody>
                  
           
            </table>
       
        
        );
   
}

function createTableAnnexesD(appareils, values) {
    // values = _.orderBy(values, ['batimentName', 'batterieName', 'appareilName','localisation'])
    values = _.sortBy(_.sortBy(values,'reglementation'),'article')
    var Results = {};
    _.map(values, c => {
        if (!Results[c.reglementation])
            Results[c.reglementation]={}

   
          
        
                Results[c.reglementation][c.article] = c
           
        

    
    });

    //////console.log(Results);

console.log(Results);

   
        return (
            <font face="Arial" size="10px">  
            <table
              
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
              
                }}
            >
             <thead>
             
                    <tr>
                        <th
                              colSpan={1}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                  marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}
                        >
                       
                               <font face="Arial" size="10px">Règlementation</font>
                          
                        </th>
                        <th
                           
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                             
                            }}
                            > <font face="Arial" size="10px"> TRAVAUX À FAIRE SUR L'APPAREIL</font></th>
                    </tr>
                </thead> 
                <tbody>
                    {_.map(Results, (c, reglementation) => {
                        var length = 1;
                        var i = 0
                        
                        return _.map(c, (d, article) => {
                            i++
                            return (
                                <tr key={article}>
                                    {i == 1 && <td 
                                        rowSpan={_.values(c).length}
                                        style={{
                                 
                                            border: "1px solid black",
                                            textAlign: "center",
                                            font: "Arial",
                                            fontSize: "10px",
                                            whiteSpace: "pre-line",
                                            wordWrap: "break-word",
                                            verticalAlign: "top",
                                   
                                        }}
                                    >
                                    <font face="Arial" size="10px">     <b>{reglementation.toUpperCase()}</b></font>
                                    </td>}
                                    <td 
                                 
                                    style={{
                                        //border: "1px solid black",
                                        borderTop: i==1 ? "1px solid black":"0px solid black",
                                        textAlign: "left",
                                        margin: 10,
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        overflowWrap: 'break-word'
                                      
                                    }}
                                    >

                                        <font face="Arial" size="10px">  
                                     
                                        <p><b>{article}</b>:<span dangerouslySetInnerHTML={{ __html: d.description }} /></p>
                                       <p> <u>Appareils concernés:</u> {d.appareils && d.appareils.length != appareils.length  ? _.map(d.appareils, (l, j) => {
                                            return l.name
                                        }).join(', ') : ' Tous les appareils'
                                        }</p>
                                                       
                                           </font>            
                                               
                                              
                                      

                                            
                                      
                                   

                                    </td>
                                </tr>
                            )
                        
                        })
                    })}
                  </tbody>
                  
           
            </table></font>
        );
   
}

function createTableAnnexesE(appareils, values) {
    values = _.sortBy(_.sortBy(values, 'reglementation'), 'article')
    var Results = {};
    _.map(values, c => {
        if (!Results[c.reglementation])
            Results[c.reglementation] = {}




        Results[c.reglementation][c.article] = c




    });

    //////console.log(Results);

   
return (<div>
    {_.map(Results,(s,reglementation)=>{
var total =0

var v = _.values(s)


        total = total + _.sum(_.map(v,f=>{
return f.appareils && f.appareils.length ? Number(f.pu)*f.appareils.length: f.pu ?Number(f.pu)*appareils.length :0 
}))
return (
            <font key={reglementation} face="Arial" size="10px">  
            <table
              
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
              
                }}
            >
             <thead>
<tr>
               <th colSpan={2}  rowSpan={2} style={{ border: '1px solid black', textAlign: 'center', backgroundColor: '#c5d1d0', font: 'Arial', whiteSpace: 'pre-line', wordWrap: 'break-word' }}><font face="Arial" size="10px">{reglementation}</font></th>
                   <th
                              colSpan={2}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                  marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}
                        >
                       
                               <font face="Arial" size="10px">Concerné</font>
                          
                        </th>
                        </tr>
                    <tr>
                        <th
                              colSpan={1}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                  marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}
                        >
                       
                               <font face="Arial" size="10px">Oui</font>
                          
                        </th>
                        <th
                           
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                    marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                             
                            }}
                            > <font face="Arial" size="10px">Non</font></th>
                    </tr>
                </thead> 
                <tbody>
                  
                        
                        { _.map(s, (d, article) => {
                            var color ="white"
                            if(d.check)
                       color='#d0e9f5'
                          
                            return (
                                <tr key={article}       style={{background:color}}>
                               <td 
                                       
                                        style={{
                                 
                                            border: "1px solid black",
                                            textAlign: "center",
                                                marginLeft: 5,
                                    marginRight: 5,
                                            font: "Arial",
                                            fontSize: "10px",
                                            whiteSpace: "pre-line",
                                            wordWrap: "break-word",
                                            verticalAlign: "top",
                                   
                                        }}
                                    >
                                    <font face="Arial" size="12px">     <b>RISQUE {article}</b></font>
                                    </td>
                                    <td 
                                 
                                    style={{
                                        //border: "1px solid black",
                                        borderTop: "1px solid black",
                                        textAlign: "left",
                                        margin: 10,
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        overflowWrap: 'break-word'
                                      
                                    }}
                                    >

                                        <font face="Arial" size="10px">  
                                     
                                        <p><span dangerouslySetInnerHTML={{ __html: d.description }} /></p>
                                          </font>  
                                            <font face="Arial" size="12px">   
                                            {d.check ? <div><p> <u>Appareils concernés:</u> {d.appareils && d.appareils.length != appareils.length ? _.map(d.appareils, (l, j) => {
                                                return l.name
                                            }).join(', ') : ' Tous les appareils'
                                            }</p>  <div style={{ textAlign: 'right', justifyContent: 'end' }}> Prix/Appareil: <b>{Number(d.pu)} € HT         </b>     Prix Total: <b>{d.appareils && d.appareils.length ? Number(d.pu)*d.appareils.length: Number(d.pu)*appareils.length } € HT</b></div></div>:''}
                                                       
                                           </font>            
                                               
                                    
                                    </td>

                                     <td 
                                 
                                    style={{
                                        //border: "1px solid black",
                                        border: "1px solid black",
                                        textAlign: "center",
                                        margin: 10,
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        overflowWrap: 'break-word'
                                      
                                    }}
                                    >

                                        <font face="Arial" size="14px">  
                                     
                                        
                                     {d.check ? <span>&#10003;</span>:' '}
                                                       
                                           </font>            
                                  
                                    </td>
                                      <td 
                                 
                                    style={{
                                        //border: "1px solid black",
                                        border: "1px solid black",
                                        textAlign: "center",
                                        margin: 10,
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        overflowWrap: 'break-word'
                                      
                                    }}
                                    >

                                        <font face="Arial" size="14px">  
                                     
                                        
                                     {d.check ? ' ':<span>&#10003;</span>}
                                                       
                                           </font>            
                                  
                                    </td>
                                </tr>
                            )
                        
                        })}
                          <tr>
                 
                              <td colSpan={4} style={{textAlign:'right',  border: "1px solid black",
                                        
                                        margin: 10,
                                        font: "Arial",
                                        fontSize: "12px",
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        overflowWrap: 'break-word',justifyContent:'end'}}>  <font face="Arial" size="12px">     <b>Montant Estimatif des Travaux hors options et variantes: {total?total:' - '} € HT </b></font></td>
                    </tr>
                   
                  </tbody>
            </table>
          
            </font>)

    })}
    
</div>)

}

function createTableAnnexesF(form, values) {
    // values = _.orderBy(values, ['batimentName', 'batterieName', 'appareilName','localisation'])
console.log(form);
    var Results = {};
    _.map(values, c => {
        if (!Results[c.localisation])
            Results[c.localisation]={}

   
        
                Results[c.localisation] = _.filter(
                    values,
                    e => {
                        return (
                        
                            e.localisation === c.localisation
                        );
                    }
                )
           
        

        return c;
    });

    //////console.log(Results);

console.log(Results);
var list = _.uniqBy(_.compact(_.map(form.annexeE,c=>{
    if(c.check)
  return  c.reglementation
  else return 
})))
if(form.annexeC.length)
   list = _.concat(list,'Travaux suivant décret 2008-1325 et autre')
        return (
            <div>
           
              <table
              
                style={{
                    width: "100%",
                   // borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
               
                }}
            ><thead>
<tr>
<th    colSpan={2}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                  marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}> <font face="Arial" size="10px"> PRÉCONISATIONS MOVVÉO DE TRAVAUX DE MODERNISATION </font></th>
</tr>
            </thead>
             <tbody>
             <tr><td  style={{
                               // border: "1px solid black",
                                textAlign: "left",
                                  marginLeft: 10,
                                    marginRight: 10,
                                
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}>
              <font face="Arial" size="10px">  Compte tenu des remarques en annexe C (Décret 2008-1325 et autre) et en annexe E (risques à éliminer sur la loi du 2 juillet 2003) et de la nécessité de garantir un degré de performance et de fiabilité, nous vous suggérons de réaliser les travaux suivants :</font>
            <ul>
           {_.map(list,(l,k)=>{
               return <li key={k}><font face="Arial" size="10px"> {l}</font></li>
           })}</ul>
           <p><font face="Arial" size="10px"> Préconisation de travaux complémentaires: <b>{form.terme_modernisation}</b> </font></p>
          <p> <font face="Arial" size="10px"> <b><u>Modernisations:</u></b></font></p>
       </td></tr>  </tbody>  </table>
            <table
              
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
               
                }}
            >
              <thead>
                    <tr>
                        <th
                            colSpan={1}
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word"
                            }}
                        >
                            <font face="Arial" size="10px"> Localisation</font>
                          
                        </th>
                        <th
                
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word"
                            }}
                        >
                          
                                {""}
                        
                        </th>
                    </tr>
                </thead> 
                <tbody>
                    {_.map(Results, (c, localisation) => {
                         var total=0
                        var length = 1;
                        var i=1
                    if(_.filter(c,k=>{
return k.localisation == localisation && !k.variante && !k.option
                    }).length)
                        return (
                            <tr key={localisation}>
                                <td
                                   /*  rowSpan={_.filter(values,f=>{
                                        return f.localisation == localisation
                                    }).length-1} */
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        verticalAlign: "top",
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {localisation}</b></font>
                                </td>
                                <td
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                         wordWrap: "break-word",
                                         overflowWrap: 'break-word'
                                    }}
                                >
                                
                                 
                                        {_.map(c, (d, k) => {
                                          
                                   console.log(d)
  if(d.variante || d.option)
  return
                                           total = total +d.pt
                                            return (
                                                <div key={k} style={{marginLeft:10}}>
                                                    <font face="Arial" size="10px"> 
                                                {i++} - {d.description}
                                                
                                          
                                                   
 
                                                        
                                                             

                                                               <div style={{ textAlign: 'right', justifyContent: 'end' }}>   Prix par appareil: <b>{d.pu} € HT </b>  -   Prix Total: <b>{d.pt} € HT</b></div>

                                                        <br/>
                                                                <font face="Arial" size="12px">
                                                                     <div><p> <u>Appareils concernés:</u> {d.appareils && d.appareils.length != form.appareils.length ? <b>{_.map(d.appareils, (l, j) => {
                                                                        return l.name
                                                                    }).join(', ')}</b> :<b>  les appareils</b>
                                                                    }</p>
                                                                        <div style={{ textAlign: 'right', justifyContent: 'end' }}> Prix/Appareil: <b>{Number(d.pu)} € HT         </b>     Prix Total: <b>{d.appareils && d.appareils.length ? Number(d.pu) * d.appareils.length : Number(d.pu) * form.appareils.length} € HT</b></div></div> 

                                                                </font>    
                                                            


                                                  
                                              
                                               
                                              </font>
                                                    <br/></div>

                                            )
                                            })
                                       }
                                          <div style={{ textAlign: 'right', justifyContent: 'end' }}><font face="Arial" size="10px">   <u>Sous-total {localisation}</u>: <b>{total} € HT</b></font></div>    
                                              
                                
                                </td>
                            </tr>
                        )
                    })}
                      <tr>
                    <td></td>
                              <td style={{textAlign:'right', justifyContent:'end',   backgroundColor: "#c5d1d0",}}>  <font face="Arial" size="12px">     <b>Montant Estimatif des travaux : {_.sum(_.compact(_.map(form.annexeF,c=>{
if(!c.variante && !c.option)
                                 return c.pt
                                })))} € HT </b></font></td>
                    </tr>
                     {_.map(Results, (c, localisation) => {
                         console.log(c)
                         var total=0
                        var length = 1;
                        var i=1
                         if(_.filter(c,k=>{
return k.localisation == localisation && k.variante 
                    }).length)
                        return (
                            <tr key={localisation}>
                                <td
                                   /*  rowSpan={_.filter(values,f=>{
                                        return f.localisation == localisation
                                    }).length-1} */
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        verticalAlign: "top",
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {localisation}</b></font>
                                </td>
                                <td
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                         wordWrap: "break-word",
                                         overflowWrap: 'break-word'
                                    }}
                                >
                                
                                 
                                        {_.map(c, (d, k) => {
                                          
                                   console.log(d)
if(!d.variante)
return
                                           total = total +d.pt
                                            return (
                                                <div key={k} style={{marginLeft:10}}>
                                                    <font face="Arial" size="10px"> 
                                               <b>Variante N° {i++}</b> - {d.description}
                                                
                                          
                                                   
 
                                                        
                                                             

                                                               <div style={{ textAlign: 'right', justifyContent: 'end' }}>   Prix par appareil: <b>{d.pu} € HT </b>  -   Prix Total: <b>{d.pt} € HT</b></div>

                                                        <br/>
                                                                <font face="Arial" size="12px">
                                                                     <div><p> <u>Appareils concernés:</u> {d.appareils && d.appareils.length != form.appareils.length ? <b>{_.map(d.appareils, (l, j) => {
                                                                        return l.name
                                                                    }).join(', ')}</b> :<b> Tous les appareils</b>
                                                                    }</p>
                                                                        <div style={{ textAlign: 'right', justifyContent: 'end' }}> Prix/Appareil: <b>{Number(d.pu)} € HT         </b>     Prix Total: <b>{d.appareils && d.appareils.length ? Number(d.pu) * d.appareils.length : Number(d.pu) * form.appareils.length} € HT</b></div></div> 

                                                                </font>    
                                                            


                                                  
                                              
                                               
                                              </font>
                                                    <br/></div>

                                            )
                                            })
                                       }
                                          <div style={{ textAlign: 'right', justifyContent: 'end' }}><font face="Arial" size="10px">   <u>Sous-total {localisation} - Variantes</u>: <b>{total} € HT</b></font></div>    
                                              
                                
                                </td>
                            </tr>
                        )
                    })}
 
                     {_.map(Results, (c, localisation) => {
                         var total=0
                        var length = 1;
                        var i=1
                      if(_.filter(c,k=>{
return k.localisation == localisation && k.option
                    }).length)
                        return (
                            <tr key={localisation}>
                                <td
                                   /*  rowSpan={_.filter(values,f=>{
                                        return f.localisation == localisation
                                    }).length-1} */
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        verticalAlign: "top",
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {localisation}</b></font>
                                </td>
                                <td
                                    style={{
                                        border: "1px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        whiteSpace: "pre-line",
                                         wordWrap: "break-word",
                                         overflowWrap: 'break-word'
                                    }}
                                >
                                
                                 
                                        {_.map(c, (d, k) => {
                                          
                                   console.log(d)
if(!d.option)
return
                                           total = total +d.pt
                                            return (
                                                <div key={k} style={{marginLeft:10}}>
                                                    <font face="Arial" size="10px"> 
                                               <b>Option N° {i++}</b> - {d.description}
                                                
                                          

                                                               <div style={{ textAlign: 'right', justifyContent: 'end' }}>   Prix par appareil: <b>{d.pu} € HT </b>  -   Prix Total: <b>{d.pt} € HT</b></div>

                                                        <br/>
                                                                <font face="Arial" size="12px">
                                                                    <div><p> <u>Appareils concernés:</u> {d.appareils && d.appareils.length != form.appareils.length ? <b>{_.map(d.appareils, (l, j) => {
                                                                        return l.name
                                                                    }).join(', ')}</b> :<b> Tous les appareils</b>
                                                                    }</p>
                                                                        <div style={{ textAlign: 'right', justifyContent: 'end' }}> Prix/Appareil: <b>{Number(d.pu)} € HT         </b>     Prix Total: <b>{d.appareils && d.appareils.length ? Number(d.pu) * d.appareils.length : Number(d.pu) * form.appareils.length} € HT</b></div></div> 

                                                                </font>    
                                                            


                                                  
                                              
                                               
                                              </font>
                                                    <br/></div>

                                            )
                                            })
                                       }
                                          <div style={{ textAlign: 'right', justifyContent: 'end' }}><font face="Arial" size="10px">   <u>Sous-total {localisation} - Options</u>: <b>{total} € HT</b></font></div>    
                                              
                                
                                </td>
                            </tr>
                        )
                    })}
                 
                  </tbody>
                  
           
            </table>
       </div>
        
        );
   
}

function createTableAnnexesG(form) {
console.log(form)
var o = 1
var t=1
var list = {}
_.map(form.annexeE,c=>{
    if(c.check){
        console.log(c)
        if(!list[c.reglementation])
        list[c.reglementation]=0
        if(!isNaN(Number(c.pu)))
  list[c.reglementation]=list[c.reglementation]+ (c.appareils && c.appareils.length ? Number(c.pu)*c.appareils.length : Number(c.pu)*form.appareils.length)
 }
})
if(form.annexeC.length)
   list['Travaux suivant décret 2008-1325 et autre'] = _.sum(_.map(form.annexeC,c=>c.pt))
 
var modernisation = _.sum(_.compact(_.map(form.annexeF,k=>{
    if(!k.variante && !k.option)
    return k.pt
})))
var options = {}

_.map(form.annexeF,k=>{
    console.log(k)
    if(k.option){
           if(!options[k.description])
           options[k.description]=0
   options[k.description]=options[k.description]+ k.pt
}
})
var variante = {}

_.map(form.annexeF,k=>{
    if(k.variante){

           if(!variante[k.description])
           variante[k.description]=0
   variante[k.description]=variante[k.description]+ k.pt
}
})
console.log(list,variante,options,modernisation)
return (
            <font  face="Arial" size="10px">  
            <table
              
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid black",
                    font: "Arial",
                    fontSize: "10px",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
              
                }}
            >
             <thead>
<tr>
                   <th
                             
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                  marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}
                        >
                       
                               <font face="Arial" size="10px">DESIGNATIONS DES ESTIMATIONS DE TRAVAUX</font>
                          
                        </th>
                         <th
                              
                            style={{
                                border: "1px solid black",
                                textAlign: "center",
                                  marginLeft: 5,
                                    marginRight: 5,
                                backgroundColor: "#c5d1d0",
                                font: "Arial",
                                whiteSpace: "pre-line",
                                wordWrap: "break-word",
                               
                                
                            }}
                        >
                       
                               <font face="Arial" size="10px">PRIX TOTAL HT</font>
                          
                        </th>
                        </tr>
                   
                </thead>
                <tbody>
                {_.map(list,(c,i)=>{
console.log(i)
              
 return( <tr key={i}>
  <td
                                  
                                    style={{
                                      border: "0px solid black",
                                            textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                    
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {i}</b></font>
                                </td><td
                                 
                                    style={{
                                          border: "0px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                      
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c)}</b></font>
                                </td>
                              
                                </tr>)
                                  })}

                                  <tr >
 <td
                              
                                    style={{
                              border: "0px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                      
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {'Modernisations'}</b></font>
                                </td>
                                <td
                                 
                                    style={{
                                     border: "0px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                        verticalAlign: "top",
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(modernisation)}</b></font>
                                </td>
                                </tr>

                                 {_.map(options,(c,i)=>{

              console.log(c,i)
 return (<tr key={i}>
  <td
                                
                                    style={{
                                        border: "0px solid black",
                                       textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                    
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"> Option n°{o++} - {i}</font>
                                </td><td
                                 
       
                                           style={{    border: "0px solid black",
                                        textAlign: "center",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                      
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c)}</b></font>
                                </td>
                              
                                </tr>)})}
 
                                {_.map(variante,(c,i)=>{

              
 
  return(<tr key={i}><td
                                    style={{
                                        border: "0px solid black",
                                        textAlign: "left",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 10,
                                        marginRight:5,
               
                                        whiteSpace: "pre-line",
                                        wordWrap: "break-word",
                                    
                                  
                                    }}
                                >

                                 <font face="Arial" size="10px">Variante n°{t++} - {i}</font>
                                </td><td
                                 
                                    style={{
                                      
                                        textAlign: "center",
                                               border: "0px solid black",
                                        font: "Arial",
                                        fontSize: "10px",
                                        marginLeft: 5,
                                          marginRight: 5,
                                        whiteSpace: "pre-line",
                                                wordWrap: "break-word",
                      
                                      
                                  
                                    }}
                                >
                                 <font face="Arial" size="10px"><b> {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c)}</b></font>
                                </td>
                              </tr>
                          
                                 ) })}
                                  
                </tbody>
                
                </table>
              
           
          
            </font>)

    
    


}
const SignIn = (props) => {
   console.log(props)
    const user = useSelector(({ custom }) => custom.contacts.user.infos)
    const form = useSelector(({ custom }) => custom.rapports.form)
const rapports = useSelector(({ custom }) => custom.rapports.entities)
    const [state,setState] = useState({loading: true});
    const classes = useStyles();
    const dispatch = useDispatch();
    console.log('form',form, rapports)
    useEffect(() => {
    return () => {
        console.log('******************* UNMOUNTED');
    };
}, []);
    useEffect(() => {
       console.log('rrrrrrr',props.match.params)
       if(props.match.params.id === 'new'){
  dispatch(Actions.setFormAudit('new', initialValuesForm))
       } else {
           if(rapports[props.match.params.id])
         dispatch(Actions.setFormAudit(props.match.params.id, rapports[props.match.params.id]))  
         else 
         dispatch(Actions.setFormAudit('new', initialValuesForm))
       }

},[props.match.params.id])

    useEffect(() => {
   if(form.data.audit && state.loading)
   setState({loading:false})
},[form.data.audit])
if(state.loading){
    return <FuseLoading />
}
function createTableModernisation(batiments, values) {

    values = _.orderBy(values,['batimentId','appareil','year'])
    //console.log(values)
    var Results = {};
    _.map(values, c => {

c.batimentName = _.find(form.data.batiments,d=>d.id == c.batimentId) ?_.find(form.data.batiments,d=>d.id == c.batimentId).name :''

c.appareilName = _.find(form.data.batteries,d=>d.id == c.appareilId) ?_.find(form.data.batteries,d=>d.id == c.appareilId) .name :_.find(form.data.appareils,d=>d.id == c.appareilId)  ? _.find(form.data.appareils,d=>d.id == c.appareilId) .name :''
        if (!Results[c.batimentName]) Results[c.batimentName] = {};

       
            if (!Results[c.batimentName][c.appareilName])
                Results[c.batimentName][c.appareilName] = {};
            if (!Results[c.batimentName][c.appareilName][c.year])
                Results[c.batimentName][c.appareilName][c.year] = _.filter(
                    values,
                    e => {
                        return (
                            e.batimentId === c.batimentId &&
                            e.appareilId === c.appareilId &&
                            e.year === c.year
                        );
                    }
                );
        

        return c;
    });

   //console.log(Results);



    return _.map(Results, (c, batiment) => {
        return <ul key={batiment}>
            <li>  <font face="Arial" size="10px"><b>{batiment}</b></font></li>
        {_.map(c,(d,appareil)=>{
            return <ul key={appareil}>
                    <li>  <font face="Arial" size="10px">{appareil}</font></li>
                <ul>
                    {_.map(d,(e,year)=>{
                        return <ul key={year}>
                            <li>  <font face="Arial" size="10px">{year}</font></li>
                            <ul>
                        {_.map(e,m=>{
                            return <li key={m.id}>  <font face="Arial" size="10px">{m.description}</font></li>
                        })}
                        </ul>
                        </ul>
                    })}
                        </ul>
                        
                </ul>
        })}
        
        </ul>
    })
  
    
}
    function handleSubmit(e) {
//////console.log(e)
        var tables6 = []
        var tables7 = []
        var tables8 = []
          var annexesC = []
               var annexesD = []
                   var annexesE = []
                         var annexesF = []
                         var annexesG=[]
           form.data.annexeD=    _.filter(form.data.annexeD, {check:true})
            
        form.data.redacteur = _.omit(user, 'settings', 'createdBy','updatedBy')
      console.log(JSON.stringify(_.clone(form.data)));
      var data = _.clone(form.data)
      data.batiments = _.map(data.batiments,c=>{
return {...c, batterie:_.compact(_.map(data.batteries,e=>{
    if(e.batimentId===c.id)
    return {...e, appareilB:_.filter(data.appareils,k=>{
        return k.batterieId === e.id
    })}
})), appareil:_.filter(data.appareils,e=>{
    return e.batimentId===c.id && !e.batterieId
})}})
//reglementation 
data.reglementation_installation = []
_.map(data.appareils, c=>{

    if(c.reglementation_IGH )
    data.reglementation_installation =_.concat(data.reglementation_installation , 'IGH')
    if(c.reglementation_ERP )
    data.reglementation_installation =_.concat(data.reglementation_installation , 'ERP')
    if(c.reglementation_habitation )
    data.reglementation_installation =_.concat(data.reglementation_installation , 'Habitation')
     if(c.reglementation_code_travail )
    data.reglementation_installation =_.concat(data.reglementation_installation , 'Code du travail')


})
 var indice = 'A'
        var number = 0
          var status = form.status?form.status:'draft'
       var createdBy =  form.createdBy?form.createdBy:_.omit(user, 'settings', 'createdBy','updatedBy')
var filename = ''
if(form.id == 'new'){
    filename = moment().format('YYYYMMDD')
}

     data.annexeE =  _.filter(form.data.annexeE, { check: true })
data.reglementation_installation = _.uniqBy(data.reglementation_installation).join(', ')
        _.map(form.data.batiments, c => {


            ReactDOM.render(
                createTableAnnexesA(c, form.data),
                document.getElementById(c.name+'_6')
            )
            // ////////////console.log(document.getElementById(c.id).outerHTML)
            tables6.push({ data: document.getElementById(c.name + '_6').outerHTML })

     
        })

        ReactDOM.render(
            createTableAnnexesB(null, form.data.defauts),
            document.getElementById('AnnexesB')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        tables7.push({ data: document.getElementById('AnnexesB').outerHTML })

        ReactDOM.render(
            createTableModernisation(null, form.data.modernisations),
            document.getElementById('modernisations')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        tables8.push({ data: document.getElementById('modernisations').outerHTML })


        ReactDOM.render(
            createTableAnnexesC(null, form.data.annexeC),
            document.getElementById('AnnexesC')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        annexesC.push({ data: document.getElementById('AnnexesC').outerHTML })

         ReactDOM.render(
             createTableAnnexesD(form.data.appareils, _.filter(form.data.annexeD, {check:true})),
            document.getElementById('AnnexesD')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        annexesD.push({ data: document.getElementById('AnnexesD').outerHTML })

         ReactDOM.render(
            createTableAnnexesE(form.data.appareils, form.data.annexeE),
            document.getElementById('AnnexesE')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        annexesE.push({ data: document.getElementById('AnnexesE').outerHTML })
        
          ReactDOM.render(
            createTableAnnexesF(form.data, form.data.annexeF),
            document.getElementById('AnnexesF')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        annexesF.push({ data: document.getElementById('AnnexesF').outerHTML })

           ReactDOM.render(
            createTableAnnexesG(form.data),
            document.getElementById('AnnexesG')
        )
        // ////////////console.log(document.getElementById(c.id).outerHTML)
        annexesG.push({ data: document.getElementById('AnnexesG').outerHTML })

        console.log({ data: { formulaire: data.rapport == 'audit' ? "Rapport d'Audit.docx" : '', fileName: 'test', data: { ...data, tables6: tables6, tables7, tables8, annexesC , annexesD, annexesE, annexesF, annexesG}, site: data.site.name, folder: '08-Rapports' }})
      
        setTimeout(async () => {
//console.log(data)
/* if(!form.id)
  form.id = FuseUtils.generateGUID() */

    //console.log(tables8)
   console.log(data.rapport)
            const token = await firebaseService.auth.currentUser.getIdToken(/* forceRefresh */ true)
            const request = axios({
                method: 'post',
                url: `${URL_API}/carbone/createRapport`,
                headers: {
                    'Accept-Encoding': 'UTF-8',
                    Authorization: `Bearer ${token}`
                },
                data: { formulaire: data.rapport == 'audit' ? "Rapport d'Audit.docx" : "Rapport d'Audit.docx", fileName: 'test', data: { ...data, tables6: tables6, tables7, tables8, annexesC, annexesD, annexesE, annexesF, annexesG}, site: data.site.name, folder: '08-Rapports' }
                //data: { ch: 'toto' }
            }).then(async response => {
          console.log(form.id,response)
                if (response.data && response.data.body && response.data.body.id) {
                    var t = await dispatch(Actions.getPreview(response.data.body.id, 'editor'))
                    //////console.log(t)
            
                        form.id = response.data.body.id
                    firebaseService.firestore.collection('rapports').doc(response.data.body ).set({ ...form, docInfos: response.data.body }).catch((err) => {
                        //////console.log(err)
                    })
                }

            }).catch(err=>{
                console.log(err)
            })

        }, 500);
    }

    console.log(form)
    return (
        <Paper className={clsx(classes.root, "flex m-12 p-12")}>

     
<div>
                     
                            <Typography variant="h5" className={'mb-12'} color="initial"> {form.rapport == 'audit' ? 'Audit' : form.rapport == 'APD' ? 'APD' : ''} </Typography>
                            <Divider className={'m-24'} />
                            <Typography variant="h5" className={'mb-12'} color="initial">Informations Générales </Typography>
                     <RapportType {...form}/>
                            <TextField
                                className={'m-12'}
                                //component={TextField}
                                name={`date`}
                                placeholder=""
                                type="date"
                                required
                    onBlur={(e) => {
                               //console.log(e.currentTarget.value)
                        dispatch(Actions.setFormAudit(form.id, { ...form.data, date: e.currentTarget.value, date_formatted : moment(e.currentTarget.value).format('Do MMM YYYY')}))
                                }}
                                defaultValue={form.data.date}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                label={`Date du rapport`}
                            />
                            <div className={'flex flex-row flex-wrap'}>
                    <SelectSites site={form.data.site && form.data.site.id ? form.data.site.id : ''} handleChange={(e) => {
                        dispatch(Actions.setFormAudit(form.id, { ...form.data, site: _.omit(e, 'address_facturation', 'updatedBy', 'createdBy', 'dropbox_id') }))
                        // props.form.setFieldValue(props.currentTarget.name, _.omit(e, 'address_facturation', 'updateBy', 'createdBy', 'dropbox_id'))
                    }} id={'site'} label={'Site'} name={'site'} />

                               
                    <SelectClients company={form.data.client && form.data.client.id ? form.data.client.id : ''} handleChange={(e) => {
                        dispatch(Actions.setFormAudit(form.id, { ...form.data, client: _.omit(e, 'address_facturation', 'updatedBy', 'createdBy') }))
                        //props.form.setFieldValue(props.currentTarget.name, _.omit(e, 'address_facturation', 'updateBy', 'createdBy'))

                    }} id={'client'} label={'Client'} name={'client'} />
        
                    <SelectClients company={form.data.gestionnaire && form.data.gestionnaire.id ? form.data.gestionnaire.id : ''} handleChange={(e) => {
                        dispatch(Actions.setFormAudit(form.id, { ...form.data, gestionnaire: _.omit(e, 'address_facturation', 'updatedBy', 'createdBy') }))
                    }} id={'gestionnaire'} label={'Gestionnaire'} name={'gestionnaire'} />
  
                    <SelectContacts client={form.data.client && form.data.client.id ? form.data.client.id : ''} contact={form.data.contact && form.data.contact.id ? form.data.contact.id : ''} gestionnaire={form.data.gestionnaire && form.data.gestionnaire.id ? form.data.gestionnaire.id : ''} handleChange={(e) => {


                        dispatch(Actions.setFormAudit(form.id, { ...form.data, contact: _.omit(e, 'address_facturation', 'updatedBy', 'createdBy', 'settings') }))
                    }} id={'contact'} label={'Contact'} name={'contact'} />
        

        
                              
                            </div>
                            <Divider className={'m-24'} />
                            <Typography variant="h5" className={'mb-12'} color="initial">Éléments vérifiées </Typography>

                
                            <Table name='elements_verifies' value={form.data.elements_verifies}/>
                            <Divider className={'m-24'} />
                <Typography variant="h5" className={'mb-12'} color="initial">Ensemble de l'installation </Typography>
   <SelectVariables id={'marque_appareil'} isMulti={false} handleChange={(e) => {
                  
                    dispatch(Actions.setFormAudit(form.id, { ...form.data, marque_appareil: e }))
                }} value={form.data.marque_appareil} label={"L'installation a été construite par:"} />

                <TextField
                className={'ml-12'}
                name='annee_construction'
                label='Année de construction'
                variant='filled'
                required
                 defaultValue={form.data.annee_construction}
                onBlur={(e) => {
                  
                    dispatch(Actions.setFormAudit(form.id, { ...form.data, annee_construction: e.currentTarget.value }))
                }}
                  InputLabelProps={{ shrink: true }}
                                        className="mt-12 mb-24 mr-12 max-w-224"

/>
                

                <SelectVariables id={'entreprise_maintenance'} isMulti={false} handleChange={(e) => {
                  
                    dispatch(Actions.setFormAudit(form.id, { ...form.data, entreprise_maintenance: e }))
                }} value={form.data.entreprise_maintenance} label={'La maintenance est assurée par:'} />
              
                            <TableBat name='batiments' value={form.data.batiments}></TableBat>
                            <Divider className={'m-24'} />
                <Typography variant="h5" className={'mb-12'} color="initial">Modernisations de l'installation </Typography>
                <Modernisation name={'modernisations'}></Modernisation>
                <Divider className={'m-24'} />
                               <Typography variant="h5" className={'mb-12'} color="initial">Audit </Typography>
                <Audit {...form}></Audit> 
                            <Divider className={'m-24'} />
                <Typography variant="h5" className={'mb-12'} color="initial">Liste des defaults</Typography>
                <DefaultTab ></DefaultTab>
                <Divider className={'m-24'} />
                  <Typography variant="h5" className={'mb-12'} color="initial">Annexe C - AMÉLIORATIONS POUR RÉPONDRE AUX EXIGENCES DE SÉCURITÉ Décret 2008 – 1325 du 15 décembre 2008. Arrêtés Divers</Typography>
                <AnnexesC name={'annexesC'}></AnnexesC>
                <Divider className={'m-24'} />
                     <Typography variant="h5" className={'mb-12'} color="initial">Annexe D - AMÉLIORATIONS POUR RÉPONDRE AUX EXIGENCES DE SÉCURITÉ BATIMENTS IGH/ERP et ARTICLES AS</Typography>
               <AnnexesD name={'annexesD'}></AnnexesD> 
                <Divider className={'m-24'} />
                     <Typography variant="h5" className={'mb-12'} color="initial">Annexe E - AMÉLIORATIONS POUR RÉPONDRE A LA LOI URBANISME ET HABITAT DU 2 JUILLET 2003</Typography>
                 <AnnexesE name={'annexesE'}></AnnexesE>
                <Divider className={'m-24'} />
             
                     <Typography variant="h5" className={'mb-12'} color="initial">Annexe F - PÉRENNITÉS ET TRAVAUX DE SÉCURITÉ</Typography>
                     <FormControl variant="filled" className={classes.formControl}>
        <InputLabel htmlFor="filled-rapport">Préconisation de travaux complémentaires: </InputLabel>
        <Select
            native
            value={form.terme_modernisation}
            onChange={(e) => {
                //console.log(e.currentTarget ? e.currentTarget.value : '')
                //console.log(e.target ? e.target.value : '')
                dispatch(Actions.setFormAudit(form.id, { ...form.data, terme_modernisation: e.target ? e.target.value : '' }))
            }}
            inputProps={{
                name: 'terme',
                id: 'filled-age-native-simple',
            }}
        >
       
            <option value={"à court terme"}>{"À court terme"}</option>
            <option value={"à moyen terme (2 à 3 ans)"}>{"À moyen terme (2 à 3 ans)"}</option>
             <option value={"à long terme (> 3 ans)"}>{"À long terme (> 3 ans)"}</option>
        
        </Select>
    </FormControl> 
                 <AnnexesF name={'annexesF'}></AnnexesF>
                      <Divider className={'m-24'} />
                            <div className={'flex flex-col flex-end '}>
                <Button type="button" onClick={handleSubmit} className="primary m-12 max-w-200" variant={"contained"} color={"secondary"}>Enregistrer</Button>

                    
                                </div>
             <Render {...form}></Render>

          
            </div>
        </Paper> 
    );
};

const Render = (form) => {
    const dispatch = useDispatch()
    const initialForm = useSelector(({ custom }) => custom.rapports.form);
    const [values, setState] = useState(form.data.batiments)
//////console.log(initialForm)
    useEffect(() => {
        if (!_.isEqual(values, initialForm.data.batiments)){
            setState(initialForm.data.batiments)
        }
        
    }, [initialForm.data.batiments])
    return (
    <React.Fragment>
{  /*   <div style={{visibility: 'hidden'}}> */}
            <div id={'modernisations'} key={'modernisations'} />
            {
                _.map(values, (b) => {
                    ////// ////////////console.log(//////////console.log(h)

                    return <div id={b.name + '_6'} key={b.id + '_6'} />
                })
            }
<br/>
            <div id={'AnnexesB'} key={'AnnexesB'} />
<br/>
             <div id={'AnnexesC'} key={'AnnexesC'} />

             <br/>
             <div id={'AnnexesD'} key={'AnnexesD'} />

                      <br/>
             <div id={'AnnexesE'} key={'AnnexesE'} />

                        <br/>
             <div id={'AnnexesF'} key={'AnnexesF'} />

                              <br/>
             <div id={'AnnexesG'} key={'AnnexesG'} />

          
    
   {/*  </div> */}
        </React.Fragment>
)

}

const Audit = () => {

    const dispatch = useDispatch()
    const form = useSelector(({ custom }) => custom.rapports.form);
    const [values, setState] = useState(form.data.audit)
    //////console.log(initialForm)

    useEffect(() => {
        if (!_.isEqual(values, form.data.audit)) {

            setState(form.data.audit ? form.data.audit : {})
        }

    }, [])
    useEffect(() => {
        if (!_.isEqual(values, form.data.audit)) {
        
            setState(form.data.audit ? form.data.audit : {})
        }

    }, [form.data.audit])

 
//console.log(form)
    return (
        <React.Fragment>
            <div className='flex flex-col'>
                <div className='flex flex-col m-12'>
               
                    <Typography variant="h5" className={'mb-12'} color="initial">Évaluation générale</Typography>
                        <div className='flex flex-col m-12'>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Qualité de la maintenance :</FormLabel>
                        <RadioGroup defaultValue={form.data.audit.qualite_maintenance} aria-label="maintenance" name="qualite_maintenance" row onChange={(e) => {

                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, qualite_maintenance: e.currentTarget.value } }))
                        }}>
                            <FormControlLabel value="satisfaisante" control={<GreenRadio />} label="Satisfaisante" />
                            <FormControlLabel value="moyennement satisfaisante" control={<GreenRadio />} label="Moyennement satisfaisante" />
                            <FormControlLabel value="insatisfaisante" control={<GreenRadio />} label="Insatisfaisante" />

                        </RadioGroup>
                    </FormControl>
                      <TextareaAutosize
                    style={{ minHeight: 50, border: '1px' }}

                    name='qualite_maintenance_comments'
                    aria-label="commentaires"
                    placeholder="Commentaires"
                    onBlur={(e)=>{
                    dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, qualite_maintenance_comments: e.currentTarget.value } }))
                    }}
                    defaultValue={form.data.audit.qualite_maintenance_comments}
                /> </div>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Nettoyage :</FormLabel>
                        <RadioGroup defaultValue={form.data.audit.nettoyage} aria-label="nettoyage" name="nettoyage" row onChange={(e) => {
                            ////////// ////////console.log(e.currentTarget.value, form.data.audit, d.num)
                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, nettoyage: e.currentTarget.value } }))
                        }}>
                            <FormControlLabel value="satisfaisant" control={<GreenRadio />} label="Satisfaisant" />
                            <FormControlLabel value="moyennement satisfaisant" control={<GreenRadio />} label="Moyennement satisfaisant" />
                            <FormControlLabel value="insatisfaisant" control={<GreenRadio />} label="Insatisfaisant" />

                        </RadioGroup>
                        <TextareaAutosize
                            style={{ minHeight: 50, border: '1px' }}

                            name='nettoyage_comments'
                            aria-label="commentaires"
                            placeholder="Commentaires"
                            onBlur={(e) => {
                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, nettoyage_comments: e.currentTarget.value } }))
                            }}
                            defaultValue={form.data.audit.nettoyage_comments}
                        />
                    </FormControl>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Graissage :</FormLabel>
                        <RadioGroup defaultValue={form.data.audit.graissage} aria-label="graissage" name="graissage" row onChange={(e) => {
                            ////////// ////////console.log(e.currentTarget.value, form.data.audit, d.num)
                       

                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, graissage: e.currentTarget.value } }))
                        }}>
                            <FormControlLabel value="satisfaisant" control={<GreenRadio />} label="Satisfaisant" />
                            <FormControlLabel value="moyennement satisfaisant" control={<GreenRadio />} label="Moyennement satisfaisant" />
                            <FormControlLabel value="insatisfaisant" control={<GreenRadio />} label="Insatisfaisant" />

                        </RadioGroup>
                    </FormControl>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Réglages :</FormLabel>
                        <RadioGroup defaultValue={form.data.audit.reglages} aria-label="reglages" name="reglages" row onChange={(e) => {
                            ////////// ////////console.log(e.currentTarget.value, form.data.audit, d.num)
                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, reglages: e.currentTarget.value } }))
                        }}>
                            <FormControlLabel value="satisfaisants" control={<GreenRadio />} label="Satisfaisants" />
                            <FormControlLabel value="moyennement satisfaisants" control={<GreenRadio />} label="Moyennement satisfaisants" />
                            <FormControlLabel value="insatisfaisants" control={<GreenRadio />} label="Insatisfaisants" />

                        </RadioGroup>
                    </FormControl>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Glisse :</FormLabel>
                        <RadioGroup defaultValue={form.data.audit.glisse} aria-label="glisse" name="glisse" row onChange={(e) => {
                            ////////// ////////console.log(e.currentTarget.value, form.data.audit, d.num)
                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, glisse: e.currentTarget.value } }))
                        }}>
                            <FormControlLabel value="satisfaisante" control={<GreenRadio />} label="Satisfaisante" />
                            <FormControlLabel value="moyennement satisfaisante" control={<GreenRadio />} label="Moyennement satisfaisante" />
                            <FormControlLabel value="insatisfaisante" control={<GreenRadio />} label="Insatisfaisante" />

                        </RadioGroup>
                    </FormControl>
                   
                </div>

            </div>

            <div className='flex flex-col m-12'>
                <Typography variant="h5" className={'mb-12'} color="initial">Couverture de la maintenance</Typography>
                <FormControl component="fieldset">
                    <FormLabel component="legend"></FormLabel>
                    <RadioGroup defaultValue={form.data.audit.couverture_maintenance} aria-label="couverture_maintenance" name="couverture_maintenance" onChange={(e) => {

                        dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, couverture_maintenance: e.currentTarget.value } }))
                    }}>
                        <FormControlLabel value="Les visites de maintenance sont correctement réalisées dans un intervalle de 6 semaines Maximum entre deux visites." control={<GreenRadio />} label="Les visites de maintenance sont Correctement réalisées dans un intervalle de 6 semaines Maximum entre deux visites" />
                        <FormControlLabel value="Les visites de maintenance ne sont pas correctement réalisées. L’intervalle de 6 semaines Maximum entre deux visites n’est pas respecté." control={<GreenRadio />} label="Les visites de maintenance ne sont pas correctement réalisées. L’intervalle de 6 semaines Maximum entre deux visites n’est pas respecté." />


                    </RadioGroup>
                </FormControl>
             <TextareaAutosize
                    style={{ minHeight: 50, border: '1px' }}

                    name='couverture_maintenance_comments'
                    aria-label="commentaires"
                    placeholder="Commentaires"
                    onBlur={(e)=>{
                    dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, couverture_maintenance_comments: e.currentTarget.value } }))
                    }}
                    defaultValue={form.data.audit.couverture_maintenance_comments}
                /> 

            </div>
            <div className='flex flex-col'>
          
                <div className='flex flex-col m-12'>
                     <Typography variant="h5" className={'mb-12'} color="initial">Fiabilité</Typography>

                    <FormControl component="fieldset">
                        <FormLabel component="legend">La fiabilité des appareils :</FormLabel>
                        <RadioGroup defaultValue={form.data.audit.fiabilite} aria-label="fiabilite_assuré" name="fiabilite" row onChange={(e) => {

                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, fiabilite: e.currentTarget.value } }))
                        }}>
                            <FormControlLabel value="est assurée." control={<GreenRadio />} label="est assurée" />
                            <FormControlLabel value="n'est plus assurée." control={<GreenRadio />} label="n'est plus assurée" />


                        </RadioGroup>
                    </FormControl>
                    <FormLabel className={' mt-12 mb-12'} component="p">Commentaires</FormLabel>
                    <TextareaAutosize
                        style={{ minHeight: 100, border: '1px' }}
                        required
                        name='fiabilite_comments'
                        aria-label="fiabilite_commentaire"
                        placeholder="Commentaires"
                    onBlur={(e)=>{
                    dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, fiabilite_comments: e.currentTarget.value } }))
                    }}
                        defaultValue={form.data.audit.fiabilite_comments}
                    /> 

                </div>

            </div>

            <div className='flex flex-col m-12'>
                  <Typography variant="h5" className={'mb-12'} color="initial">Sécurité</Typography>
                <FormControl component="fieldset">
                    <FormLabel component="h5">Décret 2008-1325</FormLabel>
                    <RadioGroup defaultValue={form.data.audit.decret_2008_1325} aria-label="decret-2008-1325" row name="decret_2008_1325" onChange={(e) => {
                        dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, decret_2008_1325: e.currentTarget.value } }))
                    }}>
                        <FormControlLabel value="Conforme" control={<GreenRadio />} label="Conforme" />
                        <FormControlLabel value="Non conforme" control={<GreenRadio />} label="Non conforme" />


                    </RadioGroup>
                </FormControl>
                <FormControl component="fieldset">
                    <FormLabel component="h5">Décret 2004-964 </FormLabel>
                    <RadioGroup defaultValue={form.data.audit.decret_2004_964} aria-label="decret_2004-964" name="decret_2004_964" row onChange={(e) => {
                   dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, decret_2004_964: e.currentTarget.value } }))
                    }}>
                        <FormControlLabel value="Conforme" control={<GreenRadio />} label="Conforme" />
                        <FormControlLabel value="Non conforme" control={<GreenRadio />} label="Non conforme" />


                    </RadioGroup>
                </FormControl>

         
                <FormControl component="fieldset">
                    <FormLabel component="h5">Les ascenceurs sont conformes ou non-conformes à la règlementation:</FormLabel>
                    <RadioGroup defaultValue={form.data.audit.conformite_ascenceur} aria-label="conforme-a-la-reglementation" name="conformite_ascenceur" row onChange={(e) => {
                        dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, conformite_ascenceur: e.currentTarget.value } }))
                   
                    }}>
                        <FormControlLabel value="conformes" control={<GreenRadio />} label="conformes" />
                        <FormControlLabel value="non-conformes" control={<GreenRadio />} label="non-conformes" />

                    </RadioGroup>

                </FormControl>
                <TextareaAutosize
                    style={{ minHeight: 50, border: '1px' }}

                    name='conformite_ascenceur_comments'
                    aria-label="commentaires"
                    placeholder="Commentaires"
                  onBlur={(e) => {

                                  dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, conformite_ascenceur_comments: e.currentTarget.value } }))
                    }}
                    defaultValue={form.data.audit.conformite_ascenceur_comments}
                />


            </div >
            <div className='flex flex-col m-12'>
                                                      <Typography variant="h5" className={'mb-12'} color="initial">Aspect général</Typography>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="h5"></FormLabel>
                                                            <RadioGroup defaultValue={form.data.audit.aspect_general} aria-label="aspect-general" row name="aspect_general" onChange={(e) => {

                                                                  dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, aspect_general: e.currentTarget.value } }))
                                                            }}>
                                                                <FormControlLabel value="bon" control={<GreenRadio />} label="bon" />
                                                                <FormControlLabel value="moyen" control={<GreenRadio />} label="moyen" />
                                                                <FormControlLabel value="médiocre" control={<GreenRadio />} label="médiocre" />


                                                            </RadioGroup>
                                                        </FormControl>
                                                        <TextareaAutosize
                                                            style={{ minHeight: 50, border: '1px' }}

                                                            name='aspect_general_comments'
                                                            aria-label="commentaires"
                                                            placeholder="Commentaires"
                                                            onBlur={(e) => {
                                                            dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, aspect_general_comments: e.currentTarget.value } }))
                                                            }}
                                                            defaultValue={form.data.audit.aspect_general_comments}
                                                        />




                                                    </div>

                                                     <div className='flex flex-col m-12'>
                                                         <Typography variant="h5" className={'mb-12'} color="initial">Qualité de déplacement</Typography>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="h5"></FormLabel>
                                                            <RadioGroup defaultValue={form.data.audit.qualite_deplacement} aria-label="qualite-deplacement" row name="qualite_deplacement" onChange={(e) => {

                                                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, qualite_deplacement: e.currentTarget.value } }))
                                                            }}>
                                                                <FormControlLabel value="bonne" control={<GreenRadio />} label="bonne" />
                                                                <FormControlLabel value="moyenne" control={<GreenRadio />} label="moyenne" />
                                                                <FormControlLabel value="médiocre" control={<GreenRadio />} label="médiocre" />


                                                            </RadioGroup>
                                                        </FormControl>
                                                        <TextareaAutosize
                                                            style={{ minHeight: 50, border: '1px' }}

                                                            name='qualite_deplacement_comments'
                                                            aria-label="commentaires"
                                                            placeholder="Commentaires"
                                                            onBlur={(e) => {
 dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, qualite_deplacement_comments: e.currentTarget.value } }))
                                                       
                                                            }}
                                                            defaultValue={form.data.audit.qualite_deplacement_comments}
                                                        />





                                                    </div>
                                                     <div className='flex flex-col m-12'>
                                                    <Typography variant="h5" className={'mb-12'} color="initial">Carnet d'entretien</Typography>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="h5">Le carnet d'entretien </FormLabel>
                                                            <RadioGroup defaultValue={form.data.audit.carnet_entretien} aria-label="carnet-entretrien" row name="carnet_entretien" onChange={(e) => {

                                                             dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, carnet_entretien: e.currentTarget.value } }))
                                                    
                                                            }}>
                                                                <FormControlLabel value="est à jour et correctement rempli" control={<GreenRadio />} label="est à jour et correctement rempli" />
                                                                <FormControlLabel value="n'est pas correctement rempli" control={<GreenRadio />} label="n'est pas correctement rempli" />
                                                                <FormControlLabel value="est absent" control={<GreenRadio />} label="est absent" />


                                                            </RadioGroup>
                                                        </FormControl>

                                                        <TextareaAutosize
                                                            style={{ minHeight: 50, border: '1px' }}

                                                            name='carnet_entretien_comments'
                                                            aria-label="commentaires"
                                                            placeholder="Commentaires"
                                                                                                                 onBlur={(e) => {
                                                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, carnet_entretien_comments: e.currentTarget.value } }))
                                                       
                                                            }}
                                                            defaultValue={form.data.audit.carnet_entretien_comments}
                                                        />



                                                    </div>
                                                     <div className='flex flex-col m-12'>
                                                         <Typography variant="h5" className={'mb-12'} color="initial">Amiante</Typography>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="h5"></FormLabel>
                                                            <RadioGroup defaultValue={form.data.audit.amiante} aria-label="amiante" row name="amiante" onChange={(e) => {

                                                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, amiante: e.currentTarget.value } }))
                                                       
                                                            }}>
                                                                <FormControlLabel value={'true'} control={<GreenRadio />} label="Applicable" />
                                                                <FormControlLabel value={'false'} control={<GreenRadio />} label="Non applicable" />



                                                            </RadioGroup>
                                                        </FormControl>
                                                        <TextareaAutosize
                                                            style={{ minHeight: 50, border: '1px' }}

                                                            name='amiante_comments'
                                                            aria-label="commentaires"
                                                            placeholder="Commentaires"
                                                                                                                onBlur={(e) => {
                                                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, amiante_comments: e.currentTarget.value } }))
                                                       
                                                            }}
                                                            defaultValue={form.data.audit.amiante_comments}
                                                        />




                                                    </div>
                                                     <div className='flex flex-col m-12'>
                                              <Typography variant="h5" className={'mb-12'} color="initial">Développement durable</Typography>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="h5"></FormLabel>
                                                            <RadioGroup defaultValue={form.data.audit.developpement_durable} aria-label="developpement_durable" row name="developpement_durable" onChange={(e) => {

                                                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, developpement_durable: e.currentTarget.value } }))
                                                       
                                                            }}>
                                                                <FormControlLabel value={'true'} control={<GreenRadio />} label="Applicable" />
                                                                <FormControlLabel value={'false'} control={<GreenRadio />} label="Non applicable" />



                                                            </RadioGroup>
                                                        </FormControl>
                                                        <TextareaAutosize
                                                            style={{ minHeight: 50, border: '1px' }}

                                                            name='developpement_durable_comments'
                                                            aria-label="commentaires"
                                                            placeholder="Commentaires"
                                                                                                                onBlur={(e) => {
                                                                dispatch(Actions.setFormAudit(form.id, { ...form.data, audit: { ...form.data.audit, developpement_durable_comments: e.currentTarget.value } }))
                                                       
                                                            }}
                                                            defaultValue={form.data.audit.developpement_durable_comments}
                                                        />




                                                    </div>

        </React.Fragment>
    )

}
const RapportType=()=>{
   const dispatch = useDispatch()
    const classes = useStyles();
    const form= useSelector(({ custom }) => custom.rapports.form);
    const [values, setState] = useState(form.data.rapport)
    //////console.log(initialForm)
   useEffect(() => {
        if (!_.isEqual(values, form.data.rapport)) {
        
            setState(form.data.rapport ? form.data.rapport : '')
        }

    }, [])   
     useEffect(() => {
        if (!_.isEqual(values, form.data.rapport)) {
        
            setState(form.data.rapport ? form.data.rapport : '')
        }

    }, [form.data.rapport])

    return  (  <TextField
         SelectProps={{
            native: true,
          }}
        select
        label={'Type de rapport'}
            value={values}
            onChange={(e) => {
              console.log(e.currentTarget ? e.currentTarget.value : '')
           console.log(e.target ? e.target.value : '')
                dispatch(Actions.setFormAudit(form.id, { ...form.data, rapport: e.target ? e.target.value : '' }))
            }}
           
        >
       
            <option value={"audit"}>{"Audit"}</option>
            <option value={"apd"}>{"APD"}</option>
        
        </TextField>
    )
}

export default withRouter(SignIn);
